module.exports = __webpack_public_path__ + "static/media/law_and_order.9d84e2ee.png";